export const hydratedValueToString = (value, separator = '') => {
  if (!value) {
    return null;
  }
  return Array.isArray(value) ? value.join(separator) : value;
};
function isURL(icon) {
  return typeof icon === 'string';
}
function isValidEmoji(icon) {
  return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
export const hydrateConfluenceIcon = (confluenceContainerType, icons, fallbacks) => {
  switch (confluenceContainerType) {
    case 'ConfluenceBlogPost':
      return hydrateIcon(icons, fallbacks, 'confluenceBlogIcon') || hydrateIcon(icons, fallbacks);
    case 'ConfluencePage':
      return hydrateIcon(icons, fallbacks, 'confluencePageIcon') || hydrateIcon(icons, fallbacks);
    default:
      return hydrateIcon(icons, fallbacks);
  }
};
export const hydrateIcon = (icons, fallbacks, fallbackKey = 'icon') => {
  if (Array.isArray(icons) && icons.length > 0) {
    const emojiIcons = icons.filter(isValidEmoji);
    if (emojiIcons.length > 0) {
      return {
        type: 'EMOJI',
        value: emojiIcons[0].value,
        // return the first emoji
        fallback: fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks[fallbackKey]
      };
    }
    const urlIcons = icons.filter(isURL);
    if (urlIcons.length > 0) {
      const hydratedIcons = hydratedValueToString(urlIcons);
      if (hydratedIcons !== null) {
        return {
          type: 'URL',
          value: hydratedIcons
        };
      }
    }
  }
  if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) {
    return {
      type: 'URL',
      value: fallbacks[fallbackKey]
    };
  }
  return null;
};